import React from "react";

export default function HomeNavSection() {
  return (
    <header className="sticky top-0 z-50 bg-background-light/85 backdrop-blur-xl border-b border-primary/8 px-6 lg:px-20 py-4 nav-enter">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="bg-primary p-1.5 rounded-xl shadow-lg shadow-primary/25">
            <span
              className="material-symbols-outlined text-white text-[22px]"
              style={{ fontVariationSettings: '"FILL" 1' }}
            >
              directions_run
            </span>
          </div>
          <h2 className="text-[1.4rem] font-black tracking-tighter">Errandi</h2>
        </div>
        <nav className="hidden md:flex items-center gap-10">
          <a
            className="text-sm font-semibold text-slate-600 hover:text-primary transition-colors relative group"
            href="#how"
          >
            How it Works
            <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full rounded-full" />
          </a>
          <a
            className="text-sm font-semibold text-slate-600 hover:text-primary transition-colors relative group"
            href="#features"
          >
            Features
            <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full rounded-full" />
          </a>
          <a
            className="text-sm font-semibold text-slate-600 hover:text-primary transition-colors relative group"
            href="#become"
          >
            Become a Runner
            <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full rounded-full" />
          </a>
          <a
            className="text-sm font-semibold text-slate-600 hover:text-primary transition-colors relative group"
            href="#fleet"
          >
            For Businesses
            <span className="absolute -bottom-0.5 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full rounded-full" />
          </a>
        </nav>
        <div className="flex items-center gap-4">
          <button className="hidden sm:block text-sm font-bold px-4 py-2 text-slate-600 hover:text-primary transition-colors">
            Log In
          </button>
          <button className="bg-primary text-white text-sm font-bold px-6 py-2.5 rounded-xl hover:shadow-lg hover:shadow-primary/25 hover:scale-[1.04] transition-all active:scale-95 relative overflow-hidden group">
            <span className="relative z-10">Get Started</span>
            <span className="absolute inset-0 bg-primary-deep scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 rounded-xl" />
          </button>
        </div>
      </div>
    </header>
  );
}
